import React, { useState } from 'react';
import { Modal } from 'antd';

function PreEFormEnergizedDialog({ handleOk, row, handleCancel }) {
  const [isLoading, setIsLoading] = useState(false);

  let energized = row.energized;
  function onOkClick() {
    setIsLoading(true);
    handleOk(row.id, row.energized, handleCancel);
  }

  return (
    <Modal title={energized === 'Y' ? 'Undo Energized':'Energize'} visible={true} onOk={onOkClick} okText='Yes' onCancel={() => handleCancel(false)}
           okButtonProps={{ loading: isLoading }} centered maskClosable={false} mask closable={false}>
      {
        energized === 'Y' ? <p><span>Are you sure you want to Undo setting this Form to ‘Energized'?</span><br/><br/>
        <span>Undoing an 'Energized' Pre-E Form should only be done if it was set 'Energized' in error or to correct information on the Pre-E Form such as REQ, Energization Date, or to update the selected assets.</span><br/><br/>
      <span>If left undone over night, any assets associated to this Form with an ‘In Service’ Status will be reverted to ‘Pending’ Status in IPS, during the nightly data sync.</span></p>
      : <p><span>Are you sure you want to set this Form to ‘Energized'?</span><br/><br/>
            <span>Setting the Pre-Energization Form to 'Energized' indicates that switching is done, the assets are in-service and under the dispatcher's authority.</span><br/><br/>
            <span>Any assets associated to this Form with a 'Pending' Status will be updated to 'In Service' Status in IPS during the nightly data sync.</span>
        </p>
      }
      </Modal>
  );
}
export default PreEFormEnergizedDialog;
